/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Warmup_AddedInputs */

const en_us2_workout_logging_warmup_added = /** @type {(inputs: Workout_Logging_Warmup_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warm-up added`)
};

const pt_br2_workout_logging_warmup_added = /** @type {(inputs: Workout_Logging_Warmup_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aquecimento adicionado`)
};

const es_419_workout_logging_warmup_added = /** @type {(inputs: Workout_Logging_Warmup_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calentamiento agregado`)
};

const pt_pt2_workout_logging_warmup_added = /** @type {(inputs: Workout_Logging_Warmup_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aquecimento adicionado`)
};

const fr_fr2_workout_logging_warmup_added = /** @type {(inputs: Workout_Logging_Warmup_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échauffement ajouté`)
};

const de_de2_workout_logging_warmup_added = /** @type {(inputs: Workout_Logging_Warmup_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufwärmen hinzugefügt`)
};

const it_it2_workout_logging_warmup_added = /** @type {(inputs: Workout_Logging_Warmup_AddedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riscaldamento aggiunto`)
};

/**
* | output |
* | --- |
* | "Warm-up added" |
*
* @param {Workout_Logging_Warmup_AddedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_warmup_added = /** @type {((inputs?: Workout_Logging_Warmup_AddedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Warmup_AddedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_warmup_added(inputs)
	if (locale === "es-419") return es_419_workout_logging_warmup_added(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_warmup_added(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_warmup_added(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_warmup_added(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_warmup_added(inputs)
	return en_us2_workout_logging_warmup_added(inputs)
});
export { workout_logging_warmup_added as "workout-logging.warmup_added" }